<template lang="pug">
div(
    :class="$style.root"
)
    IconViewResponse(
        :class="$style.icon"
        :name="iconName"
        :view="view"
    )
    div(
        :class="$style.info"
    )
        TheText(
            :class="$style.title"
            :name="'titleL'"
            :color="'foreground'"
        ) {{ title }}
        TheText(
            :name="'descriptionM'"
            :color="'foreground400'"
            :align="'center'"
        ) {{ description }}
    div(
        v-if="errorCode"
        :class="$style.error"
    )
        TheText(
            :class="$style.title"
            :name="'caption'"
            :color="'foreground400'"
        ) Идентификатор ошибки
        TheText(
            :name="'titleXL'"
            :color="'foreground'"
            :align="'center'"
        ) {{ errorCode }}
    Button(
        v-if="buttonText && buttonHref"
        :class="$style.button"
        :href="buttonHref"
    ) {{ buttonText }}
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from 'vue'

import { IconViewResponse } from '../IconViewResponse'
import { TheText } from '../TheText'
import { Button } from '../Button'

import { views, iconNameMap } from './model'

export type ResponseProps = {
    view: (typeof views)[number]
    title: string
    description: string
    errorCode?: string
    buttonText?: string
    buttonHref?: string
}

export default defineComponent({
    name: 'Response',
    props: {
        view: {
            type: String as PropType<ResponseProps['view']>,
            required: true,
        },
        title: {
            type: String as PropType<ResponseProps['title']>,
            required: true,
        },
        description: {
            type: String as PropType<ResponseProps['description']>,
            required: true,
        },
        errorCode: {
            type: String as PropType<ResponseProps['errorCode']>,
            required: false,
        },
        buttonText: {
            type: String as PropType<ResponseProps['buttonText']>,
            required: false,
        },
        buttonHref: {
            type: String as PropType<ResponseProps['buttonHref']>,
            required: false,
        },
    },
    setup(props) {
        const { view } = toRefs(props)

        const iconName = computed(() => iconNameMap[view.value])

        return {
            iconName,
        }
    },
    components: {
        IconViewResponse,
        TheText,
        Button,
    },
})
</script>

<style module lang="scss" src="./Response.module.scss" />
